import type { HttpResponse } from '@wix/yoshi-flow-editor';
import type { PanoramaErrorMonitor } from '@wix/panorama-client/dist/types/panorama-error-monitor';
import type { ErrorMonitorUserData } from '@wix/panorama-client/dist/types/types';

export const withMonitorRequestIdApiCall = async <T>({
  errorMonitor,
  responsePromise,
  type,
  category,
}: {
  errorMonitor?: PanoramaErrorMonitor<ErrorMonitorUserData>;
  responsePromise: Promise<HttpResponse<T>>;
  type: string;
  category: string;
}) => {
  const response = await responsePromise;
  errorMonitor?.addBreadcrumb({
    type,
    category,
    message: `requestId: ${response.requestId}`,
  });
  return response;
};
